/* core components */
import React, { useEffect, useState } from "react";

import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormLabel from "@material-ui/core/FormLabel";
/* custom components */
import conf from "config/env.conf.js";
import { makeStyles } from "@material-ui/core/styles";
import { useFetch } from "hooks/useFetch";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  formControl: {
    margin: theme.spacing(3)
  }
}));
const CheckboxSuspendStatus = props => {
  const [isLoading, fetchData] = useFetch(
    conf.END_POINT_URL + "/suspend/suspendStatus",
    []
  );
  const classes = useStyles();
  const [valid, setValid] = useState();
  const [, setCountAll] = useState(0);

  const [helperText, setHelperText] = useState("");

  let content = <p>กำลังโหลดข้อมูล...</p>;

  useEffect(() => {
    let suspendIdLists = [];
    for (const [, v] of Object.entries(props.supspendCheckBoxSelected)) {
      if (v.checked) {
        suspendIdLists.push(v.value);
        setCountAll(suspendIdLists.length);
      }
    }

    if (props.required && suspendIdLists.length > 0) {
      setValid(false);
      setHelperText("");
    }
    if (props.required && suspendIdLists.length === 0) {
      setValid(true);
      //setHelperText("");
      setHelperText("ต้องเลือกอย่างน้อย1อย่าง");
    }
  }, [props.supspendCheckBoxSelected, props.required]);

  if (!isLoading && typeof fetchData !== "undefined" && fetchData !== null) {
    content = (
      <div className={classes.root}>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel required={props.required} error={valid}>
            <span style={{ color: "#000", fontSize: 15 }}>
              สถานะการถูกระงับสิทธิสมัครฯ/เพิกถอนสิทธิสมัครฯ
            </span>
          </FormLabel>

          <FormGroup>
            {fetchData.data.map(suspend => (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={props.disabled}
                    checked={
                      props.supspendCheckBoxSelected[suspend.suspendStatusId]
                        .checked
                    }
                    onChange={e => {
                      props.onSupspendCheckBoxSelected(e);
                    }}
                    value={suspend.suspendStatusId}
                    name={`${suspend.suspendStatusId}`}
                  />
                }
                key={suspend.suspendStatusId}
                label={suspend.detail}
              />
            ))}
          </FormGroup>
          <FormHelperText
            style={{ color: "red", fontSize: 12, textAlign: "left" }}
          >
            {helperText}
          </FormHelperText>
        </FormControl>
      </div>
    );
  }
  return content;
};
export default CheckboxSuspendStatus;
